(() => {
    const frame = document.querySelector('[data-map]');
    const loadBtn = frame && frame.querySelector('[data-map-load]');
    if (!loadBtn) return;

    loadBtn.addEventListener('click', () => {
        const iframe = document.createElement('iframe');
        iframe.title = frame.getAttribute('data-map-title') || '';
        iframe.src = frame.getAttribute('data-map-src');
        iframe.loading = 'lazy';
        iframe.referrerPolicy = 'no-referrer-when-downgrade';
        iframe.allowFullscreen = true;
        frame.replaceChildren(iframe);
    });
})();

(() => {
    const form = document.querySelector('[data-contact-form]');
    if (!form) return;

    const root = form.closest('.contact-form') || form.parentNode;
    const live = root.querySelector('[data-contact-live]');
    const done = root.querySelector('[data-contact-done]');
    const resetBtn = root.querySelector('[data-contact-reset]');
    const status = form.querySelector('[data-contact-status]');
    const submit = form.querySelector('[data-contact-submit]');
    const label = submit.querySelector('[data-contact-label]');
    const fileInput = form.querySelector('[data-contact-file]');
    const endpoint = form.getAttribute('data-endpoint');
    const idleLabel = submit.getAttribute('data-label-idle');
    const sendingLabel = submit.getAttribute('data-label-sending');
    const MAX_FILE = 3 * 1024 * 1024;
    const HTTP_FORBIDDEN = 403;
    const HTTP_TOO_MANY_REQUESTS = 429;
    const TURNSTILE_WAIT_MS = 6000;
    const TURNSTILE_POLL_MS = 250;
    const hasTurnstile = !!form.querySelector('.cf-turnstile');
    const TURNSTILE_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
    let turnstileRequested = false;

    const loadTurnstile = () => {
        if (!hasTurnstile || turnstileRequested) return;
        turnstileRequested = true;
        const script = document.createElement('script');
        script.src = TURNSTILE_SRC;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
    };
    form.addEventListener('focusin', loadTurnstile, { once: true });
    form.addEventListener('pointerdown', loadTurnstile, { once: true });

    const selectEl = form.querySelector('[data-contact-select]');
    if (selectEl && window.TomSelect) {
        const ts = new window.TomSelect(selectEl, { controlInput: null, allowEmptyOption: false });
        const placeholder = selectEl.getAttribute('placeholder');
        if (placeholder) ts.control.setAttribute('data-placeholder', placeholder);
        const params = new URLSearchParams(window.location.search);
        const poste = params.get('poste');
        const presetKey = params.get('sujet');
        if (poste) {
            const prefix = form.getAttribute('data-apply-prefix') || 'Candidature -';
            const value = prefix + ' ' + poste;
            ts.addOption({ value: value, text: value });
            ts.setValue(value);
        } else if (presetKey) {
            const opt = [...selectEl.options].find((o) => o.dataset.key === presetKey);
            if (opt) ts.setValue(opt.value);
        }
    }

    const setStatus = (message, state) => {
        status.textContent = message || '';
        if (state) {
            status.dataset.state = state;
        } else {
            delete status.dataset.state;
        }
    };

    const toBase64 = async (file) => {
        const bytes = new Uint8Array(await file.arrayBuffer());
        let binary = '';
        for (let i = 0; i < bytes.length; i += 1) binary += String.fromCharCode(bytes[i]);
        return btoa(binary);
    };

    // The invisible challenge may still be running when the user submits:
    // give it a few seconds before giving up.
    const turnstileToken = async () => {
        if (!window.turnstile) return '';
        const deadline = Date.now() + TURNSTILE_WAIT_MS;
        let token = window.turnstile.getResponse();
        while (!token && Date.now() < deadline) {
            await new Promise((resolve) => setTimeout(resolve, TURNSTILE_POLL_MS));
            token = window.turnstile.getResponse();
        }
        return token || '';
    };

    const validatable = () => [...form.elements].filter((el) => el.willValidate && el.name !== 'website');
    const markInvalid = () => validatable().forEach((el) => el.classList.toggle('is-invalid', !el.checkValidity()));

    form.addEventListener('input', (event) => {
        const el = event.target;
        if (el.classList && el.classList.contains('is-invalid') && el.checkValidity()) {
            el.classList.remove('is-invalid');
        }
    });

    if (resetBtn) {
        resetBtn.addEventListener('click', () => {
            form.reset();
            setStatus('', null);
            done.hidden = true;
            live.hidden = false;
        });
    }

    form.addEventListener('submit', async (event) => {
        event.preventDefault();

        if (form.website.value) return;

        if (!form.checkValidity()) {
            markInvalid();
            setStatus(form.getAttribute('data-msg-validation'), 'error');
            form.reportValidity();
            return;
        }

        if (!endpoint) {
            setStatus(form.getAttribute('data-msg-error'), 'error');
            return;
        }

        const file = fileInput && fileInput.files && fileInput.files[0];
        if (file && file.size > MAX_FILE) {
            setStatus(form.getAttribute('data-msg-file'), 'error');
            return;
        }

        submit.disabled = true;
        label.textContent = sendingLabel;
        setStatus('', 'pending');

        let token = '';
        if (hasTurnstile) {
            loadTurnstile();
            token = await turnstileToken();
            if (!token) {
                setStatus(form.getAttribute('data-msg-captcha'), 'error');
                submit.disabled = false;
                label.textContent = idleLabel;
                if (window.turnstile) window.turnstile.reset();
                return;
            }
        }

        const payload = {
            nom: form.nom.value.trim(),
            societe: form.societe.value.trim(),
            email: form.email.value.trim(),
            telephone: form.telephone.value.trim(),
            sujet: form.sujet.value,
            message: form.message.value.trim(),
            consent: form.consent.checked,
            website: form.website.value
        };
        if (token) payload.turnstileToken = token;

        try {
            if (file) {
                payload.attachment = { filename: file.name, contentType: file.type, data: await toBase64(file) };
            }

            const res = await fetch(endpoint, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(payload)
            });

            if (res.ok) {
                form.reset();
                live.hidden = true;
                done.hidden = false;
            } else if (res.status === HTTP_TOO_MANY_REQUESTS) {
                setStatus(form.getAttribute('data-msg-rate'), 'error');
            } else if (res.status === HTTP_FORBIDDEN) {
                setStatus(form.getAttribute('data-msg-captcha'), 'error');
            } else {
                setStatus(form.getAttribute('data-msg-error'), 'error');
            }
        } catch (err) {
            setStatus(form.getAttribute('data-msg-error'), 'error');
        } finally {
            submit.disabled = false;
            label.textContent = idleLabel;
            // Turnstile tokens are single-use: get a fresh one for any retry
            if (window.turnstile) window.turnstile.reset();
        }
    });
})();
